/* global google */

const markers = [];

const setMarkers = function mapMarkers(items, map) {
    const icon = {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: '#826987',
        fillOpacity: 0.8,
        scale: 4,
        strokeWeight: 0,
    };

    items.map((item) => {
        const latLng = {
            lat: parseFloat(item.lat),
            lng: parseFloat(item.lng),
        };

        const marker = new google.maps.Marker({
            position: latLng,
            icon,
            map,
            //title: item.schoolname,
            id: item.id
        });

        if (typeof pageLang !== 'undefined' && pageLang === 'en') {
            marker.schoolUrl = item.url.replace('skole/', 'school/');
        }
        else {
            marker.schoolUrl = item.url;
        }

        google.maps.event.addListener(marker, 'click', function() {
            if (!this.schoolUrl) {
                return;
            }
            location.href = this.schoolUrl;
        });

        const infoWindow = new google.maps.InfoWindow();
        google.maps.event.addListener(marker, 'mouseover', function() {
            infoWindow.setContent(item.schoolname);
            infoWindow.open(map, marker);
        });
        google.maps.event.addListener(marker, 'mouseout', function() {
            infoWindow.close();
        });

        marker.foo = item.I;

        markers.push(marker);

        return null;
    });

    return markers;
};

export {
    setMarkers,
    markers,
};
